import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const UtilitySystemsEntry = () => {
  useModuleRedirect("utility-systems-module");
  return null;
};

export default UtilitySystemsEntry;
